import ColorLibrary from './ColorLibrary.json'
import ColorsBase from './ColorsBase.json'
import ColorsDark from './ColorsDark.json'
import { getBrandVersionedColors } from 'APP/Helpers/brandVersionedUtils'
import Config from 'APP/Config'

type ColorConfig = typeof ColorsBase

function getColorValues(data: Record<string, string>) {
  Object.entries(data).forEach(([key, value]) => {
    data[key] = ColorLibrary[value as keyof typeof ColorLibrary]
  })

  return data
}

const base = getColorValues(ColorsBase)
const dark = getColorValues(ColorsDark)

const Colors = getBrandVersionedColors(
  base,
  dark,
  ColorLibrary,
  Config.BRAND_VERSION
) as ColorConfig

export default Colors
